export const RedirectWebsite = {
  //Url: 'https://netdoctrine-dev.azurewebsites.net'
  Url: 'https://console.dillo.cloud'
  //Url: 'https://localhost:44336',

}
